<template>
  <v-dialog
    :value="visiblePopup"
    :width="444"
    @click:outside="onCloseClickButton"
    @keydown.esc="onCloseClickButton"
  >
    <v-card class="sensitivity-selection-popup popup-wrapper">
      <div class='close-button-section'>
        <span class='close_btn' @click='onCloseClickButton'>
          <span class="material-icons-outlined">
            close
          </span>
        </span>
      </div>
      <div class='title'> {{ $t('sensitivity.domain.popup.title') }} </div>
      <v-slider
        v-model='sensitivityUpdatedValue'
        :tick-labels="sensitivityLabels"
        :min="minValue"
        :max="maxValue"
        :step='1'
        ticks="always"
        tick-size="4"
      >
      </v-slider>
      <div class='actions'>
        <div class='btn-section'>
          <v-btn
            small
            depressed
            class="cancel-button"
            @click="onCloseClickButton"
          >
            {{ cancelSensitivityButtonCaption }}
          </v-btn>
          <v-btn small depressed class="update-button" :loading='loading' :disabled="disableSaveButton" @click="updateSensitivity()">
            {{ updateSensitivityButtonCaption }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { CONFIGURATION } from '@/constants/configuration';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SensitivitySelectionPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    sensitivityIndex: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      sensitivityUpdatedValue: this.sensitivityIndex,
    };
  },
  computed: {
    updateSensitivityButtonCaption() {
      return this.$t('update.sensitivity.domain.popup.button');
    },
    cancelSensitivityButtonCaption() {
      return this.$t('cancel.sensitivity.domain.popup.button');
    },
    sensitivityLabels() {
      return Object.values(CONFIGURATION.SensitivityOptions).map(item => this.$t(`asset.sensitivity.${item}`));
    },
    sensitivityValues() {
      return this.sensitivityLabels.map((item, index) => index);
    },
    minValue() {
      return this.sensitivityValues[0] || 0;
    },
    maxValue() {
      return this.sensitivityValues.slice(-1)[0];
    },
    disableSaveButton() {
      return this.sensitivityIndex === this.sensitivityUpdatedValue;
    },
  },
  methods: {
    onCloseClickButton() {
      this.$emit('close');
    },
    async updateSensitivity() {
      await this.$emit('updateSensitivity', this.sensitivityLabels[this.sensitivityUpdatedValue]);
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';
.sensitivity-selection-popup {
  .v-slider__tick-label {
    padding: rem(3) rem(8);
    width: rem(75);
    text-align: center;
    text-transform: capitalize !important;
  }
  // TLD uses 3-variant scale: low / medium / high
  // high is the max severity here, so it maps to critical (red)
  .v-slider__tick:first-of-type {
    .v-slider__tick-label {
      color: var(--severity-low) !important;
      background-color: var(--severity-low-label-bg) !important;
    }
  }
  .v-slider__tick:nth-of-type(2) {
    .v-slider__tick-label {
      color: var(--severity-medium) !important;
      background-color: var(--severity-medium-label-bg) !important;
    }
  }
  .v-slider__tick:last-of-type {
    .v-slider__tick-label {
      color: var(--severity-critical) !important;
      background-color: var(--severity-critical-label-bg) !important;
    }
  }
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.sensitivity-selection-popup {
  .v-slider{
    .v-slider__tick-label{
      margin-top: rem(12);
    }
  }
  &.popup-wrapper {
    width: rem(444);
    padding: rem(24) rem(32);
    display: flex;
    flex-direction: column;
    .actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: rem(35);
      .btn-section {
        display: flex;
        justify-content: flex-end;
        .update-button {
          height: rem(32);
          width: rem(51);
          border-radius: $radius-sm;
          background-color: var(--brand-primary);
          box-shadow: 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12),
          0 1px 3px 0 rgba(0,0,0,0.2) !important;

          color: var(--text-inverse) !important;
          font-size: rem(12);
          font-weight: 500;
          letter-spacing: rem(1.07);
          line-height: rem(16);
          text-align: center;

          margin-left: rem(8);
        }
        .cancel-button {
          box-sizing: border-box;
          height: rem(32);
          width: rem(86);
          border: 1px solid var(--brand-primary);
          color: var(--brand-primary);
          border-radius: $radius-sm;
          background-color: var(--bg-primary);
          box-shadow: 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12),
          0 1px 3px 0 rgba(0,0,0,0.2) !important;
        }
      }
    }
    .close-button-section {
      z-index: 2;
      .close_btn {
        float: right;
        &:hover {
          cursor: pointer;
          color: var(--brand-primary);
        }
      }
    }
    .title {
      padding-bottom: rem(35);
      margin-top: rem(-28);
      color: var(--text-primary);
      font-family: $font-family-bold;
      font-size: rem(24);
      font-weight: bold;
      line-height: rem(20);
      letter-spacing: 0;
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-top: rem(30);
      .btn-section {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
<style lang='scss'>
.sensitivity-selection-popup {
  .v-slider {
    .v-slider__tick-label {
      margin-top: 12px;
    }
  }
}
</style>
